import { TextAreaField } from "@/components/TextAreaField/TextAreaField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";
import { useShallow } from "zustand/react/shallow";
import { useStore } from "@/services/store";

type Props = {
  disabled: boolean;
};

const AdditionalInformationText = ({ disabled }: Props) => {
  const { comment, setComment } = useStore(
    useShallow((state) => ({
      comment: state.comment,
      setComment: state.setComment,
    })),
  );
  const { activeAsset, isMetadataUpdating } = useMetadataFields();
  const isupdating = isMetadataUpdating(activeAsset.id!, "comment");
  return (
    <TextAreaField
      id="comment"
      type="textarea"
      labelText="Additional information/comments"
      disabled={disabled || isupdating}
      initialValue={comment || ""}
      onBlur={(value: string) => {
        setComment(value);
      }}
    />
  );
};

export default AdditionalInformationText;
